import { config as confFunc } from 'env_def';
export const getWaimaoTrailEntryHost = () => {
    return confFunc('waimaoTrialHost');
};
